<bs-modal modalTitle="WORKFLOW.GLOBAL.RESET_DATA" [fitWidth]="true" [bsLoading]="isLoading()">
    <div class="logout-body" translate="WORKFLOW.GLOBAL.RESET_DATA_CONFIRMATION">
    </div>
    <ng-container modalActions>
        <bs-button label="COMMON.COMMON.CANCEL"
                   (click)="close()" />
        <bs-button buttonId="ConfirmResetData"
                   label="WORKFLOW.GLOBAL.RESET_DATA"
                   color="danger" icon="fas fa-rotate-right"
                   (click)="handleResetData()" />
    </ng-container>
</bs-modal>
